module.exports = __webpack_public_path__ + "img/woods_0.54f3de02.png";